import React from 'react';
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";
import { PROXY_DECLINED, PROXY_PENDING, EPIC, RX, REQUEST, REQUESTV2, GRANT } from "../../constants/textConstants";
import ProxyDeclineConfirmation from "./ProxyDeclineConfirmation";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import Spinner from "../common/spinner";
import * as ProxyHelper from "./ProxyHelper";
/**
 * Container component for the Proxy Decline Reasons page that displays after choosing decline in the email.
 *
 */

class DeclineProxy extends React.Component {

    
    constructor(props) {
        super(props);        
        // this.state = { selectedOption: 0 };
        const { location, enableProxyRequestV2, proxyDetails } = this.props;
        const { params } = this.props.match;
        const declineRequest = location && location.state ? location.state.declinedRequest : null;
        const isGrant = location && location.pathname && location.pathname.includes("/proxygrant/decline/") ? true : false;
        let name = '';
        let fullName = '';
        let requestType = '';
        let proxySource = '';
        let proxyRequestId = '';
        let isUrlParams = false;
        let proxyDetailsResponse = proxyDetails && proxyDetails.response;
        let requestorFirstName = proxyDetailsResponse ? proxyDetailsResponse.RequesterFirstName : params && params.proxyname ? this.getNameFromParams(params.proxyname) : "";

        if (typeof window !== "undefined") {

        if (declineRequest) {
                isUrlParams = false;
                fullName = this.camelizeName(declineRequest.FirstName + ' ' + declineRequest.LastName);
                requestType = declineRequest.RequestType;
                proxySource = declineRequest.ProxySource;
                proxyRequestId = declineRequest.ProxyRequestId;
                name = declineRequest.FirstName ? declineRequest.FirstName : "";
                logUI("MBHWeb.UI.ProxyDecline.DeclineFromLoggedInClient", new Date(), Tools.getURLPath());
            }
        else if (params && (params.proxyname || params.proxyrequestid)) {
                requestType = isGrant ? GRANT : (enableProxyRequestV2 && (location && location.pathname && location.pathname.includes("/proxyrequest/decline/")) ? REQUESTV2 : REQUEST);
                proxySource = location && location.pathname && location.pathname.includes("/rx/declineproxy/") ? RX :
                    params.proxysource ? params.proxysource : "";
                proxyRequestId = params.proxyrequestid ? params.proxyrequestid : null;
                name = enableProxyRequestV2 && requestorFirstName && requestorFirstName !== undefined && requestorFirstName !== "" ? this.camelizeName(requestorFirstName) : params.proxyname ? this.camelizeName(this.getNameFromParams(params.proxyname, proxySource, isGrant ? GRANT : requestType)) : "";
                isUrlParams = true;
                logUI("MBHWeb.UI.ProxyDecline.DeclineFromEmailClient", new Date(), Tools.getURLPath());
            }
           
        }

        this.state = {
            isSubmit: false,
            declineRequest: {
                requestType,
                proxySource,
                proxyRequestId,
                name,
                fullName
            },
            isGrant: isGrant
        };
        this.onDecline = this.onDecline.bind(this);
        this.retryDecline = this.retryDecline.bind(this);
        
    }

    componentDidMount() {
        const { requestType, proxySource, proxyRequestId } = this.state.declineRequest;
        logUI(`MBHWeb.UI.${ProxyHelper.getLogProxySource(proxySource)}.DeclineProxy.${ProxyHelper.getLogRequestType(requestType)}.ComponentDidMount`, new Date(), Tools.getURLPath(), JSON.stringify({ ProxyRequestId: proxyRequestId }));
    }

    getNameFromParams(name, proxySource, requestType) {
        try {
            if (name) {
                return window.atob(name);
            }
        } catch (e) {
            console.log(e);
            logUI(`MBHWeb.UI.${ProxyHelper.getLogProxySource(proxySource)}.DeclineProxy.${ProxyHelper.getLogRequestType(requestType)}.NameParsingError`, new Date(), Tools.getURLPath());
            return "";
        }
        return "";
    }

    onDecline(event) {
        const { changeRequestStatus } = this.props;
        const { requestType, proxySource, proxyRequestId } = this.state.declineRequest;
        const declineId = event && event.target.id;
        const reason = this.getReason(declineId);
        const isUnknown = declineId === "DeclineProxy_DontKnow" ? true : false;
        logUI(`MBHWeb.UI.${ProxyHelper.getLogProxySource(proxySource)}.DeclineProxy.${ProxyHelper.getLogRequestType(requestType)}.Decline`, new Date(), Tools.getURLPath(), JSON.stringify({ ProxyRequestId: proxyRequestId }));
        changeRequestStatus(proxyRequestId, proxySource, requestType, PROXY_DECLINED, reason, "", isUnknown);
        this.setState({ isSubmit: true });
    }

    camelizeName = (name) => {
        if (!name) return "";
        return name.split(' ').map(function (word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
        }).join(' ');
    }

    getReason = (choice) => {
        const buttonText = this.getButtonText();
        return choice === "DeclineProxy_DontKnow" ? buttonText.dontKnowText : buttonText.knowText;
    }

    getButtonText = () => {
        let dontKnowText = "";
        let knowText = "";
        const { name, fullName } = this.state.declineRequest;
        if (name) {
            // const nameCamelized = this.camelizeName(name);
            // const fullNameCamelized = this.camelizeName(fullName);
            dontKnowText = `I don't know who ${name} is`;
            knowText = this.state.isGrant ? `I know ${name}, but don't want access` : `I know ${name}, but don't want to give access`;
        }
        else {
            dontKnowText = "I don't know this person";
            knowText = this.state.isGrant ? "I know this person, but don't want access" : "I know this person, but don't want to give access";
        }
        return { knowText, dontKnowText };
    }

    retryDecline() {
        const { requestType, proxySource, proxyRequestId } = this.state.declineRequest;
        logUI(`MBHWeb.UI.${ProxyHelper.getLogProxySource(proxySource)}.DeclineProxy.${ProxyHelper.getLogRequestType(requestType)}.RetryDecline`, new Date(), Tools.getURLPath(), JSON.stringify({ ProxyRequestId: proxyRequestId }));
        this.setState({ isSubmit: false });
    }

    render() {
        const { changeRequestStatusAction, enableProxyRequestV2 } = this.props;
        const { isSubmit, declineRequest, isGrant } = this.state;
        const buttonText = this.getButtonText();
        const declineRequestName = declineRequest && declineRequest.name ? declineRequest.name : "this person";
        const declineRequestType = declineRequest && declineRequest.requestType ? declineRequest.requestType : "";

        return (
            <React.Fragment>{
                (isSubmit && changeRequestStatusAction && !changeRequestStatusAction.waiting &&
                    changeRequestStatusAction.request && changeRequestStatusAction.request.status !== PROXY_PENDING &&
                    (changeRequestStatusAction.success || changeRequestStatusAction.error)) ?
                    <ProxyDeclineConfirmation
                        declineRequest={declineRequest}
                        success={changeRequestStatusAction.success}
                        error={changeRequestStatusAction.error}
                        onDeclineRetry={this.retryDecline}
                    /> :
                    <div className="container-fluid body-content decline-access-proxy-container">
                        <div className="row">
                            <div className="col-12 maxWidth-content">
                                <h1 className="step-heading step-heading-md">Why do you want to decline {isGrant ? `access to ${declineRequestName}'s account?` : enableProxyRequestV2 && declineRequestType.toLowerCase() === REQUESTV2 ? "access to your account?" : "the request?"}</h1>
                                <div className="row page-form-sm">
                                    <div className="col-12">
                                        <p className="step-description">Please select the option that best describes you.</p>
                                    </div>
                                </div>

                                <div className="row page-form-sm">
                                    <div className="col-12 feedback-decline-buttons">
                                        <button className="btn btn-primary" onClick={this.onDecline} id="DeclineProxy_DontKnow">{buttonText && buttonText.dontKnowText && buttonText.dontKnowText.toUpperCase()}</button>
                                    </div>
                                </div>
                                <div className="row page-form-sm">
                                    <div className="col-12 feedback-decline-buttons">
                                        <button className="btn btn-primary" onClick={this.onDecline} id="DeclineProxy_Know">{buttonText && buttonText.knowText && buttonText.knowText.toUpperCase()}</button>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
            }

                {
                    (isSubmit && changeRequestStatusAction && changeRequestStatusAction.waiting) &&
                    <>
                        <div className="row overlay-loading-container">
                            <div className="col-12 align-self-center">
                                <Spinner />
                            </div>
                        </div>
                    </>
                }
            </React.Fragment>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        changeRequestStatusAction: state.common[types.REQUEST_PROXY_CHANGE_STATUS],
        enableProxyRequestV2: state.session.serverData ? state.session.serverData.enableProxyRequestV2 : false,
        proxyDetails: state.common[types.PROXY_DETAILS]
    };
};
const mapDispatchToProps = (dispatch) => ({
    changeRequestStatus: (proxyRequestId, proxySource, requestType, status, reason, dateOfBirth, isUnknown) =>
        dispatch({ type: types.REQUEST_PROXY_CHANGE_STATUS, data: { proxyRequestId, proxySource, requestType, status, reason, dateOfBirth, isUnknown } })
});
export default connect(mapStateToProps, mapDispatchToProps)(DeclineProxy);